import React from 'react'
import {
  DescriptionOutlined,
  ImageOutlined,
  InsertDriveFileOutlined,
  TableChartOutlined,
  VideoFileOutlined,
  ViewInArOutlined,
} from '@mui/icons-material'
import { SvgIconProps } from '@mui/material'
import { FileFormat } from '@core/entities/SiteBoxDocument'

const ICON_BY_FORMAT: Record<FileFormat, React.ComponentType<SvgIconProps>> = {
  JPEG: ImageOutlined,
  PNG: ImageOutlined,
  DOC: DescriptionOutlined,
  DOCX: DescriptionOutlined,
  DWG: ViewInArOutlined,
  DXF: ViewInArOutlined,
  XLS: TableChartOutlined,
  XLSX: TableChartOutlined,
  MP4: VideoFileOutlined,
  PDF: InsertDriveFileOutlined,
}

type FileTypeIconProps = SvgIconProps & {
  format?: FileFormat
}

export const FileTypeIcon: React.FC<FileTypeIconProps> = ({
  format,
  ...props
}) => {
  const Icon = (format && ICON_BY_FORMAT[format]) || InsertDriveFileOutlined
  return <Icon {...props} />
}
